import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomFxModule } from 'src/app/core/custom-fx/custom-fx.module';
import { GroupSharingComponent } from './group-sharing.component';
import { GroupSharingRoutingModule } from './group-sharing-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { CreateGroupPopupComponent } from './create-group-popup/create-group-popup.component';
import { JoinGroupPopupComponent } from './join-group-popup/join-group-popup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EntryRequestingPopupComponent } from './entry-requesting-popup/entry-requesting-popup.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonDialogComponent } from './common-dialog/common-dialog.component';
import { HotToastModule } from '@ngneat/hot-toast';
import { MatMenuModule } from '@angular/material/menu';
import { GroupSharingLobbyComponent } from './group-sharing-lobby/group-sharing-lobby.component';
import { GroupSharingLobbyQAComponent } from './group-sharing-lobby-qa/group-sharing-lobby-qa.component';
import { EditGroupPopupComponent } from './edit-group-popup/edit-group-popup.component';
import {MatTableModule} from "@angular/material/table";
import {MatDialogModule} from "@angular/material/dialog";
import {MatBadgeModule} from "@angular/material/badge";
import {MatTooltipModule} from "@angular/material/tooltip";

@NgModule({
  exports: [
    GroupSharingComponent,
    JoinGroupPopupComponent,
    GroupSharingLobbyComponent,
    GroupSharingLobbyQAComponent
  ],
  declarations: [
    GroupSharingComponent,
    CreateGroupPopupComponent,
    JoinGroupPopupComponent,
    EntryRequestingPopupComponent,
    CommonDialogComponent,
    GroupSharingLobbyComponent,
    GroupSharingLobbyQAComponent,
    EditGroupPopupComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule.withConfig({addOrientationBps: true}),
    SharedModule,
    CustomFxModule,
    GroupSharingRoutingModule,
    MatButtonModule,
    MatDividerModule,
    MatTabsModule,
    MatListModule,
    MatIconModule,
    FormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    HotToastModule.forRoot(),
    MatTableModule,
    MatDialogModule,
    MatBadgeModule,
    MatTooltipModule
  ],
})
export class GroupSharingModule { }
